"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusContainer = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const StyledStatusContainer = styled_components_1.default.div.withConfig({ displayName: "reports-StyledStatusContainer", componentId: "reports-1asctx5" }) `
  border-color: ${({ status }) => (status ? base_react_components_1.theme[status] : 'transparent')};
  border-radius: 8px;
  padding: 16px;
  border-width: 2px;
  border-style: solid;
`;
const Container = styled_components_1.default.div.withConfig({ displayName: "reports-Container", componentId: "reports-yz7mrx" }) `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-gap: 16px;
`;
/** The StatusContainer displays its children with a border of the color matching the status prop it is passed */
const StatusContainer = (_a) => {
    var { children, status, testId, title } = _a, props = __rest(_a, ["children", "status", "testId", "title"]);
    return (react_1.default.createElement(StyledStatusContainer, Object.assign({ "data-testid": testId, status: status }, props),
        react_1.default.createElement(base_react_components_1.Copy, { size: "sm", bold: true }, title),
        react_1.default.createElement(Container, null, children)));
};
exports.StatusContainer = StatusContainer;
exports.default = exports.StatusContainer;
//# sourceMappingURL=index.js.map